import React from 'react'
import styled from 'styled-components'

const NoDataSegment = ({ message = 'Error' }) => (
    <Container>
        <Segment>
            <Title>Nothing to display</Title>
            <Message>{message}</Message>
        </Segment>
    </Container>
)

export default NoDataSegment

const Container = styled.div`
    width: 350px;
    margin: auto;
    margin-top: 120px;
`
const Message = styled.p`
    font-size: 1.3em;
    margin-top: 50px;
`

const Segment = styled.div`
    padding: 15px;
    position: relative;
    background-color: #eff1f1;
    margin: 8px;
    border-radius: 3px;
    box-shadow: 0px 0px 10px 0px rgba(21, 24, 88, 0.1);
    border: 1px solid #d5d5d5;
`

const Title = styled.div`
    font-size: 1.3em;
    grid-column: 1;
    font-weight: bold;
    text-transform: uppercase;
    text-align: center;
    border-bottom: 1px solid #d5d5d5;

    color: ${({ theme }) => theme.recipe_title_font_color};
`
